export default {
  one: 600
};
